/* eslint-disable import/prefer-default-export */
import * as req from 'api/actions';
import * as c from './constant';

export const getBirthCertificateSettings = (
  payload = { sort_by: 'asc' },
  callback
) =>
  req.list(
    c.GET_BIRTH_CERTIFICATE_SETTINGS,
    '/api/v1/administrators/birth_certificate_settings',
    payload,
    callback
  );

export const showBirthCertificateSettings = (id, payload, callback) =>
  req.item(
    c.SHOW_BIRTH_CERTIFICATE_SETTINGS,
    `/api/v1/administrators/birth_certificate_settings/${id}`,
    payload,
    callback
  );

export const updateBirthCertificate = (id, payload, callback) =>
  req.update(
    c.UPDATE_BIRTH_CERTIFICATE_SETTINGS,
    `/api/v1/administrators/birth_certificate_settings/${id}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

